function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 5.15789C15 3.41384 13.6569 2 12 2C10.3431 2 9 3.41384 9 5.15789V12.1716L15 6.17157V5.15789ZM16.5 10.3284L17.7679 9.06054C17.9109 9.2043 18 9.40699 18 9.63158V12.5263C17.9985 15.708 15.7489 18.3918 12.75 18.7895V20.4211H14.75C15.1642 20.4211 15.5 20.7745 15.5 21.2105C15.5 21.6465 15.1642 22 14.75 22H9.25C8.83579 22 8.5 21.6465 8.5 21.2105C8.5 20.7745 8.83579 20.4211 9.25 20.4211H11.25V18.7895C10.3932 18.6758 9.59752 18.3756 8.89798 17.9304L10.038 16.7904C10.631 17.0933 11.2966 17.2632 12 17.2632C14.4853 17.2632 16.5 15.1424 16.5 12.5263V10.3284ZM15 11.8284L11.245 15.5834C11.4863 15.6492 11.7392 15.6842 12 15.6842C13.6569 15.6842 15 14.2704 15 12.5263V11.8284ZM7.60818 13.5634C7.53736 13.2296 7.5 12.8826 7.5 12.5263V9.63158C7.5 9.19557 7.16421 8.8421 6.75 8.8421C6.33579 8.8421 6 9.19557 6 9.63158V12.5263C6.00037 13.3165 6.13941 14.076 6.39416 14.7774L7.60818 13.5634Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1743 5.24006C20.7367 4.67771 20.876 3.90525 20.4854 3.51472C20.0949 3.1242 19.3224 3.2635 18.7601 3.82585L3.82599 18.7599C3.26364 19.3223 3.12434 20.0948 3.51486 20.4853C3.90539 20.8758 4.67785 20.7365 5.24021 20.1742L20.1743 5.24006Z"
});

var SvgMuteMice = function SvgMuteMice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#D1D1D6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMuteMice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/muteMice.46501795.svg";
export { ForwardRef as ReactComponent };